import React from 'react';
import { FaStar, FaTools } from 'react-icons/fa';
import { GLOBAL_COLORS } from '../../hooks';


interface SliderInstanceProps {
  skillName: string;
  skillType: string;
  starCount: number;
  openPopup: (skill: { name: string; starCount: number; skillType: string }) => void;
}

export const SliderInstance: React.FC<SliderInstanceProps> = ({
                                                                skillName,
                                                                skillType,
                                                                starCount,
                                                                openPopup,
                                                              }) => {
  return (
    <div
      className="slide w-slide"
      onClick={() =>
        openPopup({
          name: skillName,
          starCount: starCount,
          skillType: skillType,
        })
      }
    >
      <div className="slide div-block-430">
        <a href="#" className="skill-link w-inline-block">
          <div className="item-box skill_box">
            <div className="div-block-386">
              <FaTools color={GLOBAL_COLORS.icon_color} className="image-141"
                       style={{ width: '26px', height: '26px' }} />
              <div className="text-block-257" style={{ textAlign: 'center' }}>
                {skillName}
              </div>
              <div>
                <div className="html-embed-10 w-embed">
                  <div
                    className="circle per-25"
                    style={{ display: starCount ? 'inherit' : 'none' }}
                  >
                    <div className="inner">
                      <span>{starCount}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-block-252" style={{ display: 'none' }}>
                Based on: <span className="text-span-10"></span>
              </div>
              <FaStar style={{ width: '20px', height: '20px' }} color={GLOBAL_COLORS.icon_color}
                      className="image-148" />
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};
